import { Component, OnDestroy } from '@angular/core';
import { ModalController, NavController, ViewController, NavParams, AlertController, ToastController, App } from 'ionic-angular';
import { Subject } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';
import { ConfirmPage } from '../confirm/confirm';
import { EditProductPage } from '../editProduct/editProduct';

import { provider } from '../../providers/provider';

import { HomePage } from '../home/home';
import { CustomerPage } from '../account/customer/customer';
import { CustomizerProvider } from '../../providers/customizer/customizer';

@Component({
  selector: 'page-cart',
  templateUrl: 'cart.html'
})
export class CartPage implements OnDestroy {
  summary: any;
  len = 0;
  tot: any;
  valuta: any;
  order = [];
  data: any;
  creditoResiduo: any;
  customerInfo = {};
  GOTOcustomer = CustomerPage;
  private _onDestroy = new Subject();
  thereAreSlots = false;
  slotsincart = false;
  temporaryCustomer = null;

  constructor(public navCtrl: NavController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public navParams: NavParams,
    public translateService: TranslateService,
    public storage: Storage,
    public viewCtrl: ViewController,
    private modalCtrl: ModalController,
    public provider: provider,
    public app: App,
    public customizer: CustomizerProvider) {

    this.data = provider.getMenu();
    this.summary = provider.getCart();
    this.slots();

    this.temporaryCustomer = provider.getTemporaryCustomer();

    if (this.data.tavolo.itsHotelRoom) {
      // use data provided by system
      this.customerInfo = this.data.tavolo.hotelRoom;
    } else if (this.temporaryCustomer) {
      // use temporary customer previously created
      this.customerInfo = this.temporaryCustomer;
    } else {
      // use customer from storage
      this.storage.get('customer').then((customer) => {
        this.customerInfo = JSON.parse(customer);
      });
    }  

  }

  ngOnDestroy() {
    this._onDestroy.next();
  }

  ionViewDidLoad() {
    if(this.provider.getPrepaidCard()) {
      this.storage.get(this.data.settings.customercode).then((hash) => {
        this.provider.getCardBalance(hash).takeUntil(this._onDestroy).subscribe(data => {
          let tessera = JSON.parse((<any>data)._body);
          if(!this.data.tavolo.isTakeAway && !this.data.tavolo.itsHotelRoom && this.data.settings.payment.when != 'PAGADOPO') {
            this.translateService.get(['MSG_BALANCE', 'TITLE_MSG_BALANCE']).takeUntil(this._onDestroy).subscribe(msg => {

              let alert = this.alertCtrl.create({
                title: msg.TITLE_MSG_BALANCE,
                message: msg.MSG_BALANCE + tessera.valore,
                buttons: ['OK']
              });
              alert.present();
            });
          }
        });
      })
    }
  }

  slots() {
    let menu = this.data.menu.righe;

    this.thereAreSlots = menu.some(item => item.content.ctvlx == 'SLOTS')
    this.slotsincart = this.summary.some(item => item.id == 'slot')

  }

  AlertDeleteItem(qty, prodName, prodId) {
    this.translateService.get(['MESSAGE_DELETE', 'YES', 'ANNULLA']).takeUntil(this._onDestroy).subscribe(msg => {

      let name = this.provider.renderDescr(prodName)

      let alert = this.alertCtrl.create({
        title: msg.MESSAGE_DELETE,
        message: qty + 'x' + name,
        buttons: [
          {
            text: msg.ANNULLA,
            role: 'cancel'
          },
          {
            text: msg.YES,
            handler: () => {
              this.provider.deleteItemCart(prodId);
              this.getCart();
            }
          }
        ]
      });
      alert.present();
    });
  }

  AlertDeleteCart() {
    this.translateService.get(['CANCEL_ORDER', 'YES', 'ANNULLA']).takeUntil(this._onDestroy).subscribe(msg => {
      let alert = this.alertCtrl.create({
        title: msg.CANCEL_ORDER,
        buttons: [
          {
            text: msg.ANNULLA,
            role: 'cancel'
          },
          {
            text: msg.YES,
            handler: () => {
              this.provider.deleteCart();
              this.getCart();
            }
          }
        ]
      });
      alert.present();
    });
  }

  showAlert(message) {
    this.translateService.get('ERRORE').takeUntil(this._onDestroy).subscribe(msg => {

      let alert = this.alertCtrl.create({
        title: msg.ERROR,
        message: message,
        buttons: [
          {
            text: 'OK',
            role: 'cancel',
            handler: () => {
              location.reload();
            }
          }
        ]
      });
      alert.present();
    });
  }

  card() {
    let modal = this.modalCtrl.create(CustomerPage);
    modal.present();
  }

  ionViewWillEnter() {
    this.getCart();
  }

  getCart() {    
    let righe = []  
    this.len = this.summary.length;
    if (this.summary != null) {    
      this.summary.forEach(element => {
        // lookup product variant
        const varianti = element.varIngr.filter(variant => variant.quantita != 0).map(variant => {
          const variante = {
            _id : variant._id,
            ctvlx: variant.ctvlx,
            prezzo: variant.prezzo,
            quant: variant.quantita,
            descrizione : variant.descrizione.find(descrizione => descrizione.main).contenuto,
            extraProps: variant.extraProps,
            stampante: element.prodotto.content.stampante,
          }
          return variante
        })
        // lookup product row
        const rigaProdotto = {
          quant: element.quantita,
          _id: element.prodotto._id,
          updatedAt: element.prodotto.updatedAt,
          prod: {
            _id: element.prodotto.content._id,
            ctvlx: element.prodotto.content.ctvlx,
            prezzo: element.prodotto.content.prezzo,
            varIngr: varianti,
            updatedAt: element.prodotto.content.updatedAt,
            descrizione: element.prodotto.content.descrizione.find(descrizione => descrizione.main).contenuto,
            stampante: element.prodotto.content.stampante,            
            trendCustomProperties: element.prodotto.content.trendCustomProperties,
            extraProps: element.prodotto.content.extraProps.onlyCreditCard ? {'onlyCreditCard': element.prodotto.content.extraProps.onlyCreditCard} : null,
          }
        }
        righe.push(rigaProdotto);
        this.order = righe;
        this.valuta = element.prodotto.content.prezzo.valuta;        
      })
    }
    this.tot = this.provider.getTotal(righe, null);
    // this.storage.set('totale',this.tot);
    this.provider.setTotal(this.tot);
  }

  getTotal(index) {
    return this.provider.getTotal(this.order, index);
  }

  editItem(item) {
    if(item.prodotto.content.extraProps.mandatoryIngredients !== undefined && item.prodotto.content.extraProps.mandatoryIngredients) {
      if((item.prodotto.content.extraProps.mandatoryIngredients).length != 0) {
        let alert = this.alertCtrl.create({
          title: 'Errore!',
          subTitle: 'Ci dispiace ma questo articolo non è modificabile.',
          buttons: ['OK']
        });
        alert.present();
        return;
      }
    }
    
    if(item.prodotto.content.disponibilita == null) {
      let modal = this.modalCtrl.create(EditProductPage, { item: item });
      modal.onDidDismiss(data => {
        this.getCart();
      });
      modal.present();
    } else {
      let alert = this.alertCtrl.create({
        title: 'Errore!',
        subTitle: 'Ci dispiace ma questo articolo ha disponibilità limitata, non è modificabile.',
        buttons: ['OK']
      });
      alert.present();
    }
    
  }

  checkMenuExpired() {
    let expired, session_expired;
    this.translateService.get('SESSION_EXPIRED').takeUntil(this._onDestroy).subscribe(value => { session_expired = value });

    if (expired = this.provider.getMenuExpired()) {
      let alert = this.alertCtrl.create({
        title: session_expired,
        buttons: [{
          text: 'Ok',
          handler: () => {
            const navTransition = alert.dismiss();
            navTransition.then(() => {
              this.provider.clearApp()
              this.app.getRootNav().setRoot(HomePage)
            });
            return false;
          }
        }]
      });
      alert.present();
    }
    return expired;
  }

  sendData() {
    if (this.checkMenuExpired())
      return

    let modal = this.modalCtrl.create(ConfirmPage, { ordine: this.order, tot: this.tot, valuta: this.valuta });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/cart/cart.ts